import { Link } from "react-router-dom";
import { usePraxis } from "../context/PraxisContext";

export default function Footer() {
  const { settings: PRAXIS } = usePraxis();

  const openCookieSettings = (e) => {
    e.preventDefault();
    window.dispatchEvent(new Event("open-cookie-banner"));
  };

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-inner">
        <div>
          <h4>{PRAXIS.name}</h4>
          <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.88rem", lineHeight: 1.75 }}>
            {PRAXIS.role}<br />
            {PRAXIS.street}<br />
            {PRAXIS.zip} {PRAXIS.city}
          </p>
        </div>
        <div>
          <h4>Kontakt</h4>
          <a href={`tel:${PRAXIS.phoneRaw}`}>Tel: {PRAXIS.phone}</a>
          <a href={`mailto:${PRAXIS.email}`}>{PRAXIS.email}</a>
        </div>
        <div>
          <h4>Rechtliches</h4>
          <Link to="/impressum" data-testid="footer-impressum">Impressum</Link>
          <Link to="/datenschutz" data-testid="footer-datenschutz">Datenschutz</Link>
          <a href="#" onClick={openCookieSettings} data-testid="footer-cookie-settings">
            Cookie-Einstellungen
          </a>
          <Link
            to="/admin/login"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-admin-login"
            className="footer-admin-link"
          >
            Scheer
          </Link>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} {PRAXIS.name}</span>
      </div>
    </footer>
  );
}
